import { sanitizeTextForAnalytics } from "@/utils/helper"

export const getEventInfoAnalytics = data => {
  const {
    type: typeInit,
    needsProductInfo = false,
    productName = "",
    accordionStatus = {},
    isBundle = "",
  } = data

  let type = typeInit
  const status = accordionStatus["status"] ? "collapse" : "expand"
  if (type === "Parcel") {
    type = "parcel shipping"
  } else if (type === "LTL") {
    type = "freight shipping"
  } else if (type === "Services") {
    type = "e-delivery"
  }
  return JSON.stringify({
    eventAction: `checkout:order summary:${type} ${
      needsProductInfo ? "product" : status
    }`,
    eventName: `checkout:order summary:${type} ${
      needsProductInfo ? "product" : status
    }`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: needsProductInfo
      ? sanitizeTextForAnalytics(productName)
      : status,
    internalLinkPosition: `checkout${isBundle ? ":bundle" : ""}`,
    internalLinkType: "checkout:" + type,
    internalLinkZoneName: "checkout:order summary",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  })
}
